exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".detailsTopic-wrap.reported-comm .input-box-stage{vertical-align:top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/community/details-topic/detailsTopic-list/detailsTopic-list.scss
// module id = 519
// module chunks = 2